export default __webpack_public_path__ + "static/media/lacrm.9d252d36.png";